import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { BookOpen, Heart, Stethoscope, GraduationCap, Users, Scale, Leaf, Shield, Activity, Briefcase, Accessibility, Baby, Ban, UserX } from "lucide-react";

const PROGRAMS = [
  { icon: BookOpen, title: "Child Education", desc: "Enrolling out-of-school children into quality learning.", img: "https://images.pexels.com/photos/18012459/pexels-photo-18012459.jpeg?auto=compress&cs=tinysrgb&h=500&w=700" },
  { icon: Heart, title: "Child Development", desc: "Holistic growth through sports, arts, and mentorship." },
  { icon: Stethoscope, title: "Child Health & Nutrition", desc: "Mid-day meals, health camps, micronutrient care.", img: "https://images.pexels.com/photos/9345661/pexels-photo-9345661.jpeg?auto=compress&cs=tinysrgb&h=500&w=700" },
  { icon: GraduationCap, title: "Support Girl Child Education", desc: "Scholarships and mentorship for girls." },
  { icon: Users, title: "Women Empowerment", desc: "Livelihood training and micro-enterprise support.", img: "https://images.pexels.com/photos/33786726/pexels-photo-33786726.jpeg?auto=compress&cs=tinysrgb&h=500&w=700" },
  { icon: Scale, title: "Protecting Human Rights", desc: "Legal aid and awareness at the grassroots." },
  { icon: Leaf, title: "Preserving the Environment", desc: "Plantation drives and water conservation.", img: "https://images.pexels.com/photos/20356926/pexels-photo-20356926.jpeg?auto=compress&cs=tinysrgb&h=500&w=700" },
  { icon: Shield, title: "Prevent Epidemics", desc: "Vaccination, awareness, and preventive healthcare." },
  { icon: Activity, title: "Healthcare", desc: "Free clinics, diagnostic camps, specialist tie-ups.", img: "https://images.pexels.com/photos/19438562/pexels-photo-19438562.jpeg?auto=compress&cs=tinysrgb&h=500&w=700" },
  { icon: Briefcase, title: "Livelihood", desc: "Skills training and placement for rural youth." },
  { icon: Accessibility, title: "Disability Support", desc: "Assistive devices, therapy, and inclusion." },
  { icon: Baby, title: "Stop Child Labour", desc: "Rescue, rehabilitation, and back-to-school drives." },
  { icon: Ban, title: "Stop Child Marriage", desc: "Community advocacy and rescue interventions." },
  { icon: UserX, title: "Prevent Child Trafficking", desc: "Surveillance, rescue, and safe-home partnerships." },
];

export default function WhatWeDo() {
  return (
    <div className="fade-in max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-3xl mb-12">
        <div className="text-xs uppercase tracking-[0.2em] text-[#FF9933] font-bold mb-2">What We Do</div>
        <h1 className="serif text-4xl md:text-5xl lg:text-6xl font-semibold text-[#000080] leading-tight">
          14 ways we're changing <em className="text-[#FF9933] not-italic">lives</em> — everyday.
        </h1>
        <p className="mt-5 text-lg text-[#4A4A4A]">
          From classrooms to clinics, our programs reach the hardest places with dignity and love.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {PROGRAMS.map((p, i) => (
          <div key={i} className="card-hover bg-white rounded-2xl border border-[#eae5d9] overflow-hidden" data-testid={`program-${i}`}>
            {p.img && (
              <div className="aspect-[4/3] overflow-hidden">
                <img src={p.img} alt={p.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
              </div>
            )}
            <div className="p-6">
              <div className="w-11 h-11 rounded-xl bg-[#FF9933]/10 flex items-center justify-center mb-3">
                <p.icon className="w-5 h-5 text-[#FF9933]" strokeWidth={1.7} />
              </div>
              <div className="serif text-xl font-semibold text-[#000080] mb-1.5">{p.title}</div>
              <div className="text-sm text-[#4A4A4A] leading-relaxed">{p.desc}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-16 text-center">
        <Link to="/donate" data-testid="wwd-donate-cta">
          <Button className="rounded-full bg-[#FF9933] hover:bg-[#E68A2E] text-white px-8 h-12 btn-glow">Support our work</Button>
        </Link>
      </div>
    </div>
  );
}
